import React from 'react';
import PropTypes from 'prop-types';
import { useCommunities } from '../Communities/containers/communitiesDataStore';
import LoadingSpinnerInContainer from '../UI/LoadingSpinnerInContainer';
import './communityImage.less';

CommunityImage.propTypes = {
	communityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	dimensions: PropTypes.number,
	isLoading: PropTypes.bool,
};

CommunityImage.defaultProps = {
	dimensions: 50,
};

export default function CommunityImage({ communityId, dimensions, isLoading }) {
	const communitiesDataStore = useCommunities();
	const { communities, circles } = communitiesDataStore.state;

	const community = communitiesDataStore.getCommunityById(communityId);

	const logoUri = community && community.logoUri;

	const renderLogo = (logoUri, renderDimensions) => {
		const noImageFontSize = renderDimensions * 0.84 + 'px';
		renderDimensions = renderDimensions + 'px';
		return (
			<React.Fragment>
				{logoUri ? (
					<img
						alt={community.name}
						className="community-logo"
						src={logoUri}
						style={{
							height: `${renderDimensions}`,
							width: `${renderDimensions}`,
							objectFit: 'contain',
						}}
					/>
				) : (
					<div
						aria-label="Community icon"
						className="icon-community affil-no-logo"
						style={{
							height: `${renderDimensions}`,
							width: `${renderDimensions}`,
							fontSize: `${noImageFontSize}`,
						}}
					/>
				)}
			</React.Fragment>
		);
	};

	const renderParentLogo = () => {
		return circles &&
			circles.length > 0 &&
			circles.filter(c => c.childGroupId === communityId).length > 0 ? (
			<div className="parent-logo">
				{renderLogo(
					communities.find(
						c =>
							c.id ===
							circles.filter(
								c => c.childGroupId === communityId,
							)[0].parentGroupId,
					).logoUri,
					dimensions * 0.45,
				)}
			</div>
		) : (
			<React.Fragment></React.Fragment>
		);
	};

	return (
		<div
			className="community-image-container"
			style={{
				width: dimensions,
			}}>
			{!isLoading ? (
				renderLogo(logoUri, dimensions)
			) : (
				<LoadingSpinnerInContainer height={dimensions} />
			)}
			{renderParentLogo()}
		</div>
	);
}
